import type { DimensionSlug } from '@features/reports';

export const EXECUTIVE_REPORT_DIMENSION_SLUGS = [
  'aud',
  'creative',
  'channel',
] as const;

export type ExecutiveReportDimensionSlug =
  (typeof EXECUTIVE_REPORT_DIMENSION_SLUGS)[number];

export const EXECUTIVE_REPORT_DIMENSION_SLUG_SET = new Set<DimensionSlug>(
  EXECUTIVE_REPORT_DIMENSION_SLUGS
);

export const validExecutiveReportDimensionSlug = (
  value: string
): value is ExecutiveReportDimensionSlug =>
  (EXECUTIVE_REPORT_DIMENSION_SLUGS as readonly string[]).includes(value);
